import React from "react";
import { useParams } from "react-router-dom";
import Footer_menu from "../../../component/footer_menu";
import Header from "../../../component/header/Header";
import appURLs from "../../../appURL";
import { useEffect, useState } from "react";
import getFetchConfig from "../../../utils/getFetchConfig";
import Detailstyle from "../Buy_Sell_Details/Buy_Sell.module.css";
import addFreeImage from "../../../assest/images/addfreeimg.png";
import BannerImage from "../../../assest/images/Room for rent 5.png";
import { ColorRing } from "react-loader-spinner";
import SimpleImageSlider from "react-simple-image-slider";
import { Link } from "react-router-dom";
import getSymbolFromCurrency from "currency-symbol-map";
import GoogleMapReact from "google-map-react";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import SocialMediaLink from "../../../component/socialMediaLink/socialMediaLink";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import Banner from "../../../component/Banner/Banner";
import moment from 'moment-timezone';
import 'moment-duration-format';

function Local_Details({ latitudes, longitudes }) {
  const navigate = useNavigate();
  const { buyId } = useParams();
  const fetchConfig = getFetchConfig(),
    appURL = appURLs();

  const [eventDetailsData, setEventDetailsData] = useState(null);
  const [imageArray, setImageArray] = useState([]);
  const [favStatus, setFavStatus] = useState(false);
  const [myTimezone, setTimeZone] = useState('');

  const [favStatus2, setFavStatus2] = useState([]);

  const [originLat, setOriginalLat] = useState([]);
  const [originalLang, setOriginalLang] = useState([]);

  const [myUseriD, setmyUseriD] = useState("");

  const [lat, setLat] = useState(null);
  const [lang, setLang] = useState(null);
  const [reportError, setReportError] = useState('');

  const reportingOptions = [
    "Inappropriate",
    "Irrelevant",
    "Repetitive",
    "Other",
  ];
  const [showOptions, setShowOptions] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [isReportSent, setIsReportSent] = useState(false);
  const [customMessage, setCustomMessage] = useState("");
  const [isMyReport, setIsMyRePORT] = useState(false);
  const [subCategoryRelatedAds, setsubCategoryRelatedAds] = useState();
  const [relatedAdsdata, serelatedAdsdata] = useState([]);
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [url, seturl] = useState();
  const [isShareOpenlink, setIsShareOpenlink] = useState(false);
  const [shareID, setshareId] = useState("");
  const [adsdynamicType, setAdsDynamicType] = useState("");
  const [linktoyourwebsite, setLinktoyourwebsite] = useState(false);
  const relatedAdsdataImageArray = [];

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpens] = useState(false);
  const [initialImageClicked, setInitialImageClicked] = useState(false);

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setIsOpens(true);
    setInitialImageClicked(true);
  };

  const closeLightbox = () => {
    setIsOpens(false);
    setPhotoIndex(0);
    setInitialImageClicked(false);
  };

  let subtitle;
  const [modalIsOpen, setIsOpen] = useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // Set the subtitle reference when the modal opens
    if (subtitle) {
      subtitle.style.color = "#212127";
    }
  }

  function closeModal() {
    setIsOpen(false);
     setReportError('');
    setSelectedOption('');
    setCustomMessage('');
  }

  const geetingDataLTLNG = (lat, lang) => {
    setLat(lang);
    setLang(lat);
  };

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 768 },
      items: 4,
      slidesToSlide: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 4,
      slidesToSlide: 4,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const fetchAdDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const response = await fetch(
        `${appURL}/posts/buysell/ad_details?adsId=${buyId}`,
        {
          ...fetchConfig,
          method: "GET",
          headers: headers,
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const jsonData = await response.json();
    

      const cleanedDescriptions =
        jsonData.ads_details.adsInfo.descriptions.replace(/<[^>]+>/g, "");
      jsonData.ads_details.adsInfo.descriptions = cleanedDescriptions;

      const images = jsonData.ads_details.adsInfo.image || [];
      const imageUrls = images.map((img) => ({
        url: img.url,
      }));
      const isLinkYourWebsite = jsonData.ads_details.addons_validity.find(
        (web) => web.name === "Link to your website"
      );
      if (isLinkYourWebsite) {
        setLinktoyourwebsite(true)
      }
      //   setAdDetails(jsonData);
      setTimeZone(jsonData.ads_details.location_timezone)
      setImageArray(imageUrls);
      setEventDetailsData(jsonData);
      setmyUseriD(jsonData.ads_details.userId);
      setIsMyRePORT(jsonData.ads_details.is_Reported);
      setsubCategoryRelatedAds(jsonData.ads_details.adsInfo.sub_category?.name);
      setFavStatus(jsonData.ads_details.is_favorite);
      setOriginalLang(jsonData.ads_details.adsInfo.location.coordinates[0]);
      setOriginalLat(jsonData.ads_details.adsInfo.location.coordinates[1]);
      setAdsDynamicType(jsonData.ads_details.adsType)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const currentDates = new Date();
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false, // Use 24-hour format
  };

  const localTimeString = currentDates.toLocaleString('en-US', options);
  const formattedDateTime = `${currentDates.getFullYear()}-${(currentDates.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${currentDates.getDate().toString().padStart(2, '0')} ${currentDates
      .getHours()
      .toString()
      .padStart(2, '0')}:${currentDates.getMinutes().toString().padStart(2, '0')}:${currentDates
        .getSeconds()
        .toString()
        .padStart(2, '0')}`;

  const getTimeSinceCreation = (dateString) => {

    // let dateString = eventDetailsData.ads_details.active_on_virtual;

    if (!dateString) {
      return "Invalid date";
    }

    // Split the string at "T" and concatenate the date and time parts
    let parts = dateString.split("T");
    let extractedDate = parts[0] + "T" + parts[1].split(".")[0];

    // console.log(extractedDate, "extractedDate");
    const convertToTimeZone = (datetime, fromTimeZone, toTimeZone) => {
      return moment.tz(datetime, fromTimeZone).tz(toTimeZone).format('YYYY-MM-DD HH:mm:ss');
    };

    const originalDatetime = extractedDate;

    const timezoneString = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const targetTimeZone = timezoneString;

    const convertedDatetime = convertToTimeZone(originalDatetime, myTimezone, targetTimeZone);


   

    if (formattedDateTime && convertedDatetime) {
      const secondsDiff = moment.duration(moment(formattedDateTime).diff(convertedDatetime)).asSeconds();


      if (secondsDiff < 60) {
        return "just now";
      } else if (secondsDiff < 3600) {
        const minutesDiff = Math.floor(secondsDiff / 60);
        return minutesDiff === 1 ? "1 minute ago" : `${minutesDiff} minutes ago`;
      } else if (secondsDiff < 86400) {
        const hoursDiff = Math.floor(secondsDiff / 3600);
        return hoursDiff === 1 ? "1 hour ago" : `${hoursDiff} hours ago`;
      } else if (secondsDiff < 172800) {
        return "Yesterday";
      } else {
        const daysDiff = Math.floor(secondsDiff / 86400);
        return daysDiff === 1 ? "1 day ago" : `${daysDiff} days ago`;
      }
    }
  }

  useEffect(() => {
    fetchAdDetails();
  }, [buyId, favStatus]);


  const fetchData = async () => {
    try {
      if (subCategoryRelatedAds) {
        const token = localStorage.getItem("token");
        const headers = {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        };

        const response = await fetch(
          `${appURL}/posts/buysell/fetchAds?sub_category=${subCategoryRelatedAds?.name}&perpage=10&latitude=${latitudes}&longitude=${longitudes}`,
          {
            headers: headers,
          }
        );

        if (response.ok) {
          const jsonData = await response.json();

          const mergedData = [
            // ...jsonData.AdOnsData.featuredData,
            ...jsonData.records,
          ];


          // Check if jsonData.records is an array and not empty
          if (Array.isArray(mergedData) && mergedData.length > 0) {
            const data = mergedData.filter((item) => item._id !== buyId);

            const favourite = data.map((record) => record.is_favorite);
            setFavStatus2(favourite);

            serelatedAdsdata(data);
          } else {
            console.error("jsonData.records is not an array or is empty");
          }
        } else {
          console.error("Failed to fetch data. Status:", response.status);
        }
      }
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    }
  };


  useEffect(() => {
    fetchData();
  }, [subCategoryRelatedAds, lat, lang, buyId, latitudes, longitudes]);

  if (!eventDetailsData) {
    return (
      <div className={Detailstyle.myLoader}>
        <ColorRing
          visible={true}
          height="80"
          width="80"
          ariaLabel="blocks-loading"
          wrapperStyle={{}}
          wrapperClass="blocks-wrapper"
          colors={["#F17D3A", "#F17D3A", "#F17D3A", "#F17D3A", "#F17D3A"]}
        />
      </div>
    );
  }

  const { addons_validity } = eventDetailsData.ads_details;

  const websiteUrl = eventDetailsData.ads_details.website_url;

  const handleViewWebsite = () => {
    if (websiteUrl && websiteUrl.trim() !== "") {
      const fullUrl = websiteUrl.startsWith('http://') || websiteUrl.startsWith('https://')
        ? websiteUrl
        : `http://${websiteUrl}`;

      const link = document.createElement('a');
      link.href = fullUrl;
      link.target = '_blank';

      const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      link.dispatchEvent(clickEvent);
    } else {
      alert("Website URL is not available.");
    }
  };



  const handleCall = () => {
    const primaryNumber =
      eventDetailsData.ads_details.lister_basic_info.primary_mobile_number
        .primary_phone_number;
    const secondaryNumber =
      eventDetailsData.ads_details.lister_basic_info.secondary_mobile_number
        .secondary_phone_number;

    if (primaryNumber) {
      window.location.href = `tel:${primaryNumber}`;
    } else if (secondaryNumber) {
      window.location.href = `tel:${secondaryNumber}`;
    } else {
      alert("No phone numbers available for calling.");
    }
  };

  const defaultProps = {
    center: {
      lat: originLat,
      lng: originalLang,
    },
    zoom: 11,
  };

  const userInfo = localStorage.getItem("user");
  const adsData = JSON.parse(userInfo);

  // localStorage.setItem("userIdchat", adsData.userId)

  if (adsData && 'userId' in adsData) {
    localStorage.setItem("userIdchat", adsData.userId);
  } else {
    console.error("adsData is null or userId is not defined");
  }

  const handleChat = () => {
    console.log("eventDetailsData", eventDetailsData);
    localStorage.setItem("adsTypeChat", "Buy & Sell");
    localStorage.setItem("adsIdChat", eventDetailsData.ads_details._id);
    localStorage.setItem("sellerIdChat", eventDetailsData.ads_details.userId);
    if (myUseriD === adsData.userId) {
      toast.error("You cannot able to chat with yourself")
    }
    else {
      localStorage.setItem("buyerId", JSON.parse(localStorage.getItem("user"))?.userId);
      navigate("/chat", { state: { message: eventDetailsData?.ads_details?.userDetails } })
    }
  }

  // console.log(adsData.userId, "8765434567876546787654567")

  // adsData.userId==myUseriD

  const handleSendReport = () => {
     if (!selectedOption) {
      setReportError('Please select a reason');
      return;
    }

    // Clear error if valid
    setReportError('');
    const adsInfo = localStorage.getItem("adsInfo");
    const adsData = JSON.parse(adsInfo);

    const adsid = parseInt(buyId, 20);

    let messageToSend = selectedOption;

    if (selectedOption === "Other") {
      messageToSend = customMessage;
    }

    const requestBody = {
      message: messageToSend,
      adsid: buyId,
      ads_type: adsdynamicType,
    };

    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    };

    fetch(`${appURL}/posts/ads/create-report`, {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: headers,
    })
      .then((response) => {
        if (response.ok) {
          setIsReportSent(true);
          setIsOpen(false);
          toast.success("Report has been sent. Thank you!");
          fetchAdDetails();
        } else {
          console.error("Error sending the report.");
        }
      })
      .catch((error) => {
        console.error("Error sending the report:", error);
      });
  };

  const handleReportClick = () => {
    setShowOptions(true);
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
      setReportError('');
  };
  const buttonHnadler = (id) => {
    const windowHeight = window.innerHeight;
    const scrollPosition = Math.floor(windowHeight * 0.8);

    window.scrollTo(0, scrollPosition);

    navigate(`/buySellDetails/${id}`);

    window.location.reload();
  };

  const shareSocialMediaLink = (event, id) => {
    event.stopPropagation();
    const baseUrl = window.location.origin;
    let url = `${baseUrl}/buySellDetails/${id}`;
    setshareId(id);
    seturl(url);
    setIsShareOpen(!isShareOpen);
  };

  const sharelink = (id) => {
    const baseUrl = window.location.origin;
    let url = `${baseUrl}/buySellDetails/${id}`;
    seturl(url);
    setIsShareOpenlink(!isShareOpenlink);
  };

  const handleHeartIconClick = (_id) => {
    const adsInfo = localStorage.getItem("adsInfo");
    const adsData = JSON.parse(adsInfo);

    const requestBody = {
      adId: buyId,
      ads_type: adsdynamicType,
      isfavorite: !favStatus,
    };

    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    fetch(`${appURL}/posts/ads/create-favorite`, {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: headers,
    })
      .then((response) => {
        if (response.ok) {
          if (!favStatus) {
            toast.success("Item added to Favourite");
          } else if (favStatus) {
            toast.error("Item removed from Favorite");
          }

          fetchAdDetails();
        
        } else {
          console.error("Error sending the report.");
        }
      })
      .catch((error) => {
        console.error("Error sending the report:", error);
      });

   
  };



  const tokenExist = localStorage.getItem("token");
  const handleHeartIconClick2 = (event, index, _id) => {
    event.stopPropagation();

    const adsInfo = localStorage.getItem("adsInfo");
    const adsData = JSON.parse(adsInfo);


    const currentStatus = favStatus2[index];

    const requestBody = {
      adId: _id,
      ads_type: adsdynamicType,
      isfavorite: !currentStatus,
    };

    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    fetch(`${appURL}/posts/ads/create-favorite`, {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: headers,
    })
      .then((response) => {
        if (response.ok) {
          // fetchData();
         
          return response.json();
        } else {
          throw new Error("Response not OK");
        }
      })
      .then((data) => {
        setFavStatus2((prevFavStatus) => ({
          ...prevFavStatus,
          [index]: !currentStatus,
        }));

        if (data.favoriteAd) {
          toast.success("Item added to Favorite");
        } else {
          toast.error("Item removed from Favorite");
        }

        fetchData();
        // console.log("Favorite status updated successfully");
      })
      .catch((error) => {
        console.error("Error sending the report:", error);
      });
  };


  function formatDate(dateString) {
    const options = { month: 'long', year: 'numeric' };
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString(undefined, options);
    return formattedDate.replace(' ', ', '); // Add a comma and space after the month
  }

  const currentDate = new Date().toISOString().split('T')[0];
  return (
    <>
      {/* <Header getCoordinates={geetingDataLTLNG} /> */}
      {/* Work starts from here */}

      <div className={Detailstyle.Main_wrapper_section}>
        {/* <div className={Detailstyle.top_header_bar} >
                <div>
                    <img src="/src/assets/logo Manehariya 2.png" alt="" />
                </div>
                <div className={Detailstyle.search_bar_list} >
                    <div className={Detailstyle.search_box}>
                        <button className={Detailstyle.search_btn} ><i className="fa-solid fa-magnifying-glass"></i></button>
                        <input className={Detailstyle.search_input} type="text" placeholder="What are you looking for?" />

                    </div>
                    <div className={Detailstyle.dropdownbar}>
                        <img src="/src/assets/Group (3).png" alt="" />
                        <form >
                            <select id={Detailstyle.parent_selector}  className={Detailstyle.event_type_select}>
                                <option value="">Select Category</option>
                                <option value="cat-1">CLOTHES</option>
                                <option value="cat-2">HOME APPLIANCES</option>
                                <option value="cat-3">OUTDOOR</option>
                            </select>
                        </form>
                        <div className={Detailstyle.search_button_list}>
                            <button>Search</button>
                        </div>
                    </div>
                </div>
                <div className={Detailstyle.user_details} >
                    <div className={Detailstyle.address_name}>
                        <img src="/src/assets/image 6.png" alt="" />
                        <p> California, Los Angeles</p>
                    </div>
                    <div className={Detailstyle.user_detail_lists}>
                        <i className="fa-solid fa-heart"></i>
                        <i className="fa-brands fa-facebook-messenger"></i>
                        <img src="/src/assets/Group 1686552277.png" alt="" />
                        <div className={Detailstyle.form_item}>
                            <div className={Detailstyle.select_dropdown} >
                                <select className={Detailstyle.big}>
                                    <option>Robert</option>
                                    <option>Choose me 2</option>
                                    <option>Choose me 3</option>
                                </select>
                                <img src="/src/assets/Ellipse 1 (4).png" alt="" />
                            </div>
                        </div>
                    </div>
                    <button className={Detailstyle.post_button}>Post Ad</button>
                </div>

            </div> */}
        {/* <div className={Detailstyle.nav_bar_menu} >
                <ul>
                    <li>Rentals</li>
                    <li>Jobs</li>
                    <li>Events</li>
                    <li>Buy & Sell</li>
                    <li>Babysitters & Nannies</li>
                    <li>Local Biz & services</li>
                </ul>
            </div> */}

        <div>
          {/* <img src={addFreeImage} alt="" style={{ width: "100%" }} /> */}
        </div>
        <div className={Detailstyle.breadcrumb_bar_list}>
          <ul className={Detailstyle.breadcrumb_bar}>
            <li>Home</li>

            <li>
              <i className="fa-solid fa-angles-right"></i>
              Buy & Sell Services
            </li>
            <li>
              <i className="fa-solid fa-angles-right"></i>
              Buy & Sell Details
            </li>
          </ul>
        </div>

        <div className={Detailstyle.slider_image_details}>
          <div className={Detailstyle.slider_image}>
            <div className={Detailstyle.detailsec_banner}>
              {/* {imageArray.length > 0 ? (
                <SimpleImageSlider
                  width={900}
                  height={550}
                  images={imageArray}
                  showNavs={imageArray.length > 1 ? true : false}
                  showBullets={imageArray.length > 1 ? true : false}
                />
              ) : (
                <img src={BannerImage} alt="Dummy" />
              )} */}


              {initialImageClicked ? (
                <div>
                  {/* {imageArray.map((image, index) => (
            <img
              key={index}
              src={image.url}
              alt={`Image ${index + 1}`}
              onClick={() => openLightbox(index)}
              style={{ width: '100px', height: '100px', margin:'5px', cursor: 'pointer' }}
            />
          ))} */}

                  <SimpleImageSlider
                    width='100%'
                    height={550}
                    images={imageArray}
                    showNavs={imageArray.length > 1 ? true : false}
                    showBullets={imageArray.length > 1 ? true : false}
                    onClick={(index) => openLightbox(index)}
                  />

                </div>
              ) : (
                <div>
                  {imageArray.length > 0 ? (
                    <SimpleImageSlider
                      width='100%'
                      height={550}
                      images={imageArray}
                      showNavs={imageArray.length > 1 ? true : false}
                      showBullets={imageArray.length > 1 ? true : false}
                      onClick={(index) => openLightbox(index)}
                    />
                  ) : (
                    <img
                      src={BannerImage}
                      alt="Dummy Image"
                      style={{ width: '700px', height: '550px', cursor: 'pointer' }}
                      onClick={() => openLightbox(0)}
                    />
                  )}
                </div>
              )}


              {isOpen && (
                <Lightbox
                  mainSrc={imageArray.length > 0 ? imageArray[photoIndex].url : BannerImage}
                  nextSrc={imageArray.length > 0 ? imageArray[(photoIndex + 1) % imageArray.length].url : BannerImage}
                  prevSrc={imageArray.length > 0 ? imageArray[(photoIndex + imageArray.length - 1) % imageArray.length].url : BannerImage}
                  onCloseRequest={closeLightbox}
                  onMovePrevRequest={() => setPhotoIndex((photoIndex + (imageArray.length || 1) - 1) % (imageArray.length || 1))}
                  onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % (imageArray.length || 1))}
                />
              )}


              <div className={Detailstyle.feature_img}>
                {eventDetailsData.ads_details.addons_validity.some(
                  (item) => item.name === "Featured" && item.active_on <= currentDate && item.expired_on >= currentDate
                ) ? (
                  <svg
                    width="91"
                    height="26"
                    viewBox="0 0 91 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      y="0.935547"
                      width="91"
                      height="25"
                      rx="4"
                      fill="#F07639"
                    />
                    <path
                      d="M14.7585 17.9355V9.20827H20.5369V10.7296H16.6037V12.8091H20.1534V14.3304H16.6037V17.9355H14.7585ZM21.7781 17.9355V9.20827H27.6587V10.7296H23.6232V12.8091H27.3562V14.3304H23.6232V16.4142H27.6758V17.9355H21.7781ZM30.63 17.9355H28.6527L31.6655 9.20827H34.0433L37.0518 17.9355H35.0746L32.8885 11.2026H32.8203L30.63 17.9355ZM30.5064 14.5051H35.1768V15.9455H30.5064V14.5051ZM36.7035 10.7296V9.20827H43.8711V10.7296H41.1992V17.9355H39.3754V10.7296H36.7035ZM50.4421 9.20827H52.2873V14.8759C52.2873 15.5123 52.1353 16.0691 51.8313 16.5463C51.5302 17.0236 51.1083 17.3958 50.5657 17.6628C50.0231 17.927 49.391 18.0591 48.6694 18.0591C47.945 18.0591 47.3114 17.927 46.7688 17.6628C46.2262 17.3958 45.8043 17.0236 45.5032 16.5463C45.2021 16.0691 45.0515 15.5123 45.0515 14.8759V9.20827H46.8967V14.7182C46.8967 15.0506 46.9691 15.3461 47.114 15.6046C47.2617 15.8631 47.4691 16.0662 47.7362 16.214C48.0032 16.3617 48.3143 16.4355 48.6694 16.4355C49.0273 16.4355 49.3384 16.3617 49.6026 16.214C49.8697 16.0662 50.0756 15.8631 50.2205 15.6046C50.3683 15.3461 50.4421 15.0506 50.4421 14.7182V9.20827ZM53.8054 17.9355V9.20827H57.2486C57.9077 9.20827 58.4702 9.32617 58.9361 9.56197C59.4048 9.79492 59.7614 10.1259 60.0057 10.5549C60.2528 10.981 60.3764 11.4824 60.3764 12.0591C60.3764 12.6387 60.2514 13.1373 60.0014 13.5549C59.7514 13.9696 59.3892 14.2878 58.9148 14.5094C58.4432 14.731 57.8722 14.8418 57.2017 14.8418H54.8963V13.3588H56.9034C57.2557 13.3588 57.5483 13.3105 57.7812 13.214C58.0142 13.1174 58.1875 12.9725 58.3011 12.7793C58.4176 12.5861 58.4759 12.3461 58.4759 12.0591C58.4759 11.7694 58.4176 11.525 58.3011 11.3262C58.1875 11.1273 58.0128 10.9767 57.777 10.8745C57.544 10.7694 57.25 10.7168 56.8949 10.7168H55.6506V17.9355H53.8054ZM58.5185 13.964L60.6875 17.9355H58.6506L56.5284 13.964H58.5185ZM61.6804 17.9355V9.20827H67.5611V10.7296H63.5256V12.8091H67.2585V14.3304H63.5256V16.4142H67.5781V17.9355H61.6804ZM72.1218 17.9355H69.0281V9.20827H72.1474C73.0252 9.20827 73.7809 9.38299 74.4144 9.73242C75.0479 10.079 75.5352 10.5776 75.8761 11.2282C76.2198 11.8787 76.3917 12.6571 76.3917 13.5634C76.3917 14.4725 76.2198 15.2537 75.8761 15.9071C75.5352 16.5605 75.0451 17.062 74.4059 17.4114C73.7695 17.7608 73.0082 17.9355 72.1218 17.9355ZM70.8732 16.3546H72.0451C72.5906 16.3546 73.0494 16.258 73.4215 16.0648C73.7965 15.8688 74.0778 15.5662 74.2653 15.1571C74.4556 14.7452 74.5508 14.214 74.5508 13.5634C74.5508 12.9185 74.4556 12.3915 74.2653 11.9824C74.0778 11.5733 73.7979 11.2722 73.4258 11.079C73.0536 10.8858 72.5948 10.7892 72.0494 10.7892H70.8732V16.3546Z"
                      fill="#ffffff"
                    />
                  </svg>
                ) : (
                  ""
                )}
              </div>
            </div>

            <img
              className={Detailstyle.slider_image_det}
              src="/src/assets/Group 1686553298.png"
              alt=""
            />

            {/* <div className={Detailstyle.address_details_text}>
                <h2>
                  {eventDetailsData.ads_details.adsInfo.title
                    ? eventDetailsData.ads_details.adsInfo.title
                    : ""}
                </h2>

                

                {eventDetailsData.ads_details.addons_validity &&
                  eventDetailsData.ads_details.addons_validity.length > 0 &&
                  (eventDetailsData.ads_details.addonategs_validity.some(
                    (addon) => addon.name === "Urgent"
                  ) ? (
                    <button>Urgent</button>
                  ) : eventDetailsData.ads_details.addons_validity.some(
                      (addon) => addon.name === "Upcoming Event"
                    ) ? (
                    <button>Upcoming Event</button>
                  ) : null)}
              </div> */}



            <div className={Detailstyle.location_box_wrap}>
              {/* <img src="/src/assets/image 6 (1).png" alt="" /> */}

              <div>
                <div className={Detailstyle.labeloo}>
                  <h2>
                    {eventDetailsData.ads_details.adsInfo.title
                      ? eventDetailsData.ads_details.adsInfo.title
                      : ""}
                  </h2>
                </div>
                <p>
                  {eventDetailsData.ads_details.adsInfo.location.location_name
                    ? eventDetailsData.ads_details.adsInfo.location
                      .location_name
                    : ""}
                </p>
              </div>

              <div>
                {eventDetailsData.ads_details.addons_validity.length > 0 && (
                  eventDetailsData.ads_details.addons_validity.map((addon, index) => (
                    addon.name === "Urgent" && addon.active_on <= currentDate && addon.expired_on >= currentDate ? (
                      <button
                        key={index}
                        className={Detailstyle.label_css}
                      >
                        {addon.name}
                      </button>
                    ) : null
                  ))
                )}

              </div>
            </div>
            {/* <span>Close to AIIMS and IIT and IGI Airport</span> */}

            <div className="view-btn">
              <div className="heart_count">
                <svg
                  width="25"
                  height="18"
                  viewBox="0 0 25 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.3064 7.90968C23.8506 8.62284 23.8506 9.58561 23.3064 10.2976C21.5921 12.5395 17.4793 17.1555 12.6775 17.1555C7.87577 17.1555 3.76293 12.5395 2.04867 10.2976C1.78388 9.95615 1.64014 9.53606 1.64014 9.10365C1.64014 8.67125 1.78388 8.25116 2.04867 7.90968C3.76293 5.66782 7.87577 1.05182 12.6775 1.05182C17.4793 1.05182 21.5921 5.66782 23.3064 7.90968V7.90968Z"
                    stroke="#C9C9C9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.6776 12.5544C14.58 12.5544 16.1222 11.0094 16.1222 9.10362C16.1222 7.1978 14.58 5.65283 12.6776 5.65283C10.7752 5.65283 9.23297 7.1978 9.23297 9.10362C9.23297 11.0094 10.7752 12.5544 12.6776 12.5544Z"
                    stroke="#C9C9C9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <span>{eventDetailsData.ads_details.view_count || 0}</span>

              </div>
            </div>



            <div className={Detailstyle.date_time}>
              <h4>
                Listed on :&nbsp;
                {getTimeSinceCreation(eventDetailsData.ads_details.active_on_virtual)}
                <span>
                  , Ad ID :&nbsp;
                  {eventDetailsData.ads_details.advertisement_id
                    ? eventDetailsData.ads_details.advertisement_id
                    : ""}
                </span>
              </h4>
            </div>
            <div className={Detailstyle.details_description_text}>
              <h2>Description</h2>
              <p>
                {eventDetailsData.ads_details.adsInfo.descriptions
                  ? eventDetailsData.ads_details.adsInfo.descriptions
                  : ""}
              </p>

              {/* <div>
                <h2>Details : </h2>
              </div> */}
              <div className={Detailstyle.linking_apart}>
                <div className={Detailstyle.slot_booking_wrap}>
                  <p>
                    Category : &nbsp;
                    <span>
                      {eventDetailsData.ads_details.adsInfo.category?.name
                        ? eventDetailsData.ads_details.adsInfo.category?.name
                        : ""}
                    </span>
                  </p>

                  <p>
                    Sub Category :
                    <span>
                      {" "}
                      &nbsp;
                      {eventDetailsData.ads_details.adsInfo.sub_category?.name
                        ? eventDetailsData.ads_details.adsInfo.sub_category?.name
                        : ""}
                    </span>
                  </p>

                  {eventDetailsData.ads_details.adsInfo.user_type.length > 0 && (
                    <p>
                      Seller Type: &nbsp;
                      <span>
                        {eventDetailsData.ads_details.adsInfo.user_type
                          ? eventDetailsData.ads_details.adsInfo.user_type
                          : ""}
                      </span>
                    </p>
                  )}

                  {eventDetailsData.ads_details.adsInfo.quantity && (
                    <p>
                      Inventory : &nbsp;
                      <span>
                        {eventDetailsData.ads_details.adsInfo.quantity
                          ? eventDetailsData.ads_details.adsInfo.quantity
                          : ""}
                      </span>
                    </p>
                  )}

                  {eventDetailsData.ads_details.adsInfo.video_link && (
                    <p>
                      Youtube Video : &nbsp;
                      <span>
                        <a
                          style={{ color: "blue", textDecoration: "none" }}
                          href={eventDetailsData.ads_details.adsInfo.video_link}
                        >
                          {eventDetailsData.ads_details.adsInfo.video_link}
                        </a>
                      </span>
                    </p>
                  )}


                </div>
                <div className={Detailstyle.slot_booking_wrap}>
                  {(eventDetailsData.ads_details?.adsInfo?.category?._id !== '652d142622376d2465c9f337' && eventDetailsData.ads_details?.adsInfo?.category?._id
                    !== '652d142722376d2465c9f351') &&

                    <p>
                      Product Condition : &nbsp;
                      <span>
                        {eventDetailsData.ads_details.adsInfo.product_condition
                          ? eventDetailsData.ads_details.adsInfo.product_condition
                          : ""}
                      </span>
                    </p>
                  }
                  {eventDetailsData.ads_details.adsInfo.product_model && (
                    <p>
                      Product model : &nbsp;
                      <span>
                        {eventDetailsData.ads_details.adsInfo.product_model}
                      </span>
                    </p>
                  )}

                  {eventDetailsData.ads_details.adsInfo.payment_mode.length >
                    0 ? (
                    <p>
                      Payment Mode : &nbsp;
                      <span>
                        {eventDetailsData.ads_details.adsInfo.payment_mode
                          ? eventDetailsData.ads_details.adsInfo.payment_mode
                            .map((mode) => mode.replace(/\\|"|\[|\]/g, ""))
                            .join(", ")
                          : ""}
                      </span>
                    </p>
                  ) : (
                    ""
                  )}


                  {(eventDetailsData.ads_details?.adsInfo?.category?._id !== '652d142622376d2465c9f337' && eventDetailsData.ads_details?.adsInfo?.category?._id
                    !== '652d142722376d2465c9f351') &&

                    <p>
                      Fullfilment : &nbsp;
                      <span>
                        {eventDetailsData.ads_details.adsInfo.fullfilment
                          ? eventDetailsData.ads_details.adsInfo.fullfilment
                            .map((value) => value.replace(/\\|"|\[|\]/g, ""))
                            .join(", ")
                          : ""}
                      </span>
                    </p>
                  }

                </div>
              </div>
            </div>

            <div className={Detailstyle.workingHours}>
              {eventDetailsData.ads_details.adsInfo.working_hours ? (
                <div>
                  <h4>Availability</h4>
                  {eventDetailsData.ads_details.adsInfo.working_hours
                    .week_days &&
                    Object.keys(
                      eventDetailsData.ads_details.adsInfo.working_hours.week_days
                    ).length > 0 ? (
                    <p>
                      <strong>Weekdays :</strong>{" "}
                      {eventDetailsData.ads_details.adsInfo.working_hours
                        .week_days.is_24_hour
                        ? "Open 24 hours"
                        : `${eventDetailsData.ads_details.adsInfo.working_hours.week_days.open_at} - ${eventDetailsData.ads_details.adsInfo.working_hours.week_days.close_at}`}
                    </p>
                  ) : null}

                  {eventDetailsData.ads_details.adsInfo.working_hours
                    .week_ends &&
                    Object.keys(
                      eventDetailsData.ads_details.adsInfo.working_hours.week_ends
                    ).length > 0 ? (
                    <p>
                      <strong>Weekends :</strong>{" "}
                      {eventDetailsData.ads_details.adsInfo.working_hours
                        .week_ends.is_24_hour
                        ? "Open 24 hours"
                        : `${eventDetailsData.ads_details.adsInfo.working_hours.week_ends.open_at} - ${eventDetailsData.ads_details.adsInfo.working_hours.week_ends.close_at}`}
                    </p>
                  ) : null}

                  {eventDetailsData.ads_details.adsInfo.working_hours
                    .appointment &&
                    typeof eventDetailsData.ads_details.adsInfo.working_hours
                      .appointment === "string" ? (
                    <p>
                      <strong>Appointment :</strong>{" "}
                      {
                        eventDetailsData.ads_details.adsInfo.working_hours
                          .appointment
                      }
                    </p>
                  ) : null}

                  {eventDetailsData.ads_details.adsInfo.working_hours
                    .is_24_seven ? (
                    <p>
                      <strong>Open 24/7</strong>
                    </p>
                  ) : null}
                </div>
              ) : null}
            </div>
          </div>
          <div className={Detailstyle.detail_left_side2}>
            <div className={Detailstyle.detail_left_side}>
              <div className={Detailstyle.client_side_details}>
                <div className={Detailstyle.user_side_details}>
                  <div className={Detailstyle.user_side_details1}>
                    {/* <span> 500.00 </span> <p>$ 480.00$ </p> */}

                    {/* <p>
  {eventDetailsData.ads_details.adsInfo.price.is_contact
    ? "Please Contact"
    : eventDetailsData.ads_details.adsInfo.price.amount !== null
    ? `Price : ${getSymbolFromCurrency(eventDetailsData.ads_details.adsInfo.price.currency)} ${eventDetailsData.ads_details.adsInfo.price.amount}`
    : eventDetailsData.ads_details.adsInfo.price.negotiable
    ? "Negotiable"
    : ""}
</p> */}

                    <div className={Detailstyle.but_det}>
                      {/* <p>
  {eventDetailsData.ads_details.adsInfo.price.is_contact && "Please Contact"}
  {eventDetailsData.ads_details.adsInfo.price.amount !== null &&
    eventDetailsData.ads_details.adsInfo.price.amount === 0
      ? "Free"
      : `${getSymbolFromCurrency(eventDetailsData.ads_details.adsInfo.price.currency)} ${eventDetailsData.ads_details.adsInfo.price.amount} `}
  {eventDetailsData.ads_details.adsInfo.price.negotiable && "Negotiable"}
</p> */}

                      <p>
                        {eventDetailsData.ads_details.price_drop ? (
                          <>
                            <span style={{ textDecoration: "line-through", fontSize: "18px" }}>
                              {getSymbolFromCurrency(eventDetailsData.ads_details.adsInfo.price.currency)}
                              {eventDetailsData.ads_details.adsInfo.price.amount}
                            </span>{" "}
                            {getSymbolFromCurrency(eventDetailsData.ads_details.adsInfo.price.currency)}
                            {eventDetailsData.ads_details.price_drop}
                          </>
                        ) : (
                          eventDetailsData.ads_details.adsInfo.price.amount === 0
                            ? "Free"
                            : eventDetailsData.ads_details.adsInfo.price.is_contact
                              ? "Please Contact"
                              : eventDetailsData.ads_details.adsInfo.price.amount !== undefined ? `${getSymbolFromCurrency(eventDetailsData.ads_details.adsInfo.price.currency)}
                             ${eventDetailsData.ads_details.adsInfo.price.amount}`
                                : 'Free'
                        )}

                        {" "}{eventDetailsData.ads_details.adsInfo.price.negotiable &&
                          eventDetailsData.ads_details.adsInfo.price.amount !== 0 &&
                          "Negotiable"}
                      </p>

                    </div>
                  </div>


                  <div className={Detailstyle.share_heart}>
                    <div className="heart_hover">
                      {!favStatus ? (
                        <div
                          onClick={(event) => {
                            event.preventDefault();
                            handleHeartIconClick(eventDetailsData._id);
                          }}
                        >
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_181_9810)">
                              <path
                                d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                                fill="white"
                              />
                              <path
                                d="M15.5591 10.9359L15.9594 11.471L16.3598 10.9359C17.0879 9.96261 18.2546 9.33008 19.5558 9.33008C21.764 9.33008 23.5593 11.1288 23.5593 13.358C23.5593 14.2675 23.4143 15.1066 23.1624 15.8851L23.1614 15.8884C22.5573 17.8001 21.3181 19.3442 19.9761 20.4976C18.6318 21.6529 17.2131 22.3913 16.3006 22.7018L16.3006 22.7018L16.2952 22.7037C16.2277 22.7275 16.1059 22.7481 15.9594 22.7481C15.8129 22.7481 15.6912 22.7275 15.6236 22.7037L15.6236 22.7036L15.6183 22.7018C14.7058 22.3913 13.287 21.6529 11.9427 20.4976C10.6006 19.3442 9.36144 17.8001 8.75734 15.8884L8.75735 15.8884L8.7563 15.8851C8.50442 15.1066 8.35938 14.2675 8.35938 13.358C8.35938 11.1289 10.1547 9.33008 12.363 9.33008C13.6642 9.33008 14.8309 9.96261 15.5591 10.9359Z"
                                stroke="black"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_181_9810">
                                <rect width="32" height="32" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      ) : (
                        <div
                          onClick={(event) => {
                            event.preventDefault();
                            handleHeartIconClick(eventDetailsData._id);
                          }}
                        >
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_315_9939)">
                              <path
                                d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                                fill="white"
                              />
                              <path
                                d="M19.5558 8.83008C18.0897 8.83008 16.7775 9.54288 15.9594 10.6364C15.1413 9.54288 13.8291 8.83008 12.363 8.83008C9.87627 8.83008 7.85938 10.8551 7.85938 13.358C7.85938 14.3219 8.01327 15.2129 8.28057 16.0391C9.56037 20.0891 13.5051 22.511 15.4572 23.1752C15.7326 23.2724 16.1862 23.2724 16.4616 23.1752C18.4137 22.511 22.3583 20.0891 23.6381 16.0391C23.9054 15.2129 24.0593 14.3219 24.0593 13.358C24.0593 10.8551 22.0425 8.83008 19.5558 8.83008Z"
                                fill="#FF7700"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_315_9939">
                                <rect width="32" height="32" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      )}
                    </div>



                    <div
                      className={Detailstyle.share_icon}
                      onClick={() => {
                        sharelink(buyId);
                      }}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M17.9997 19.9996C17.7312 20.0088 17.4637 19.9639 17.213 19.8675C16.9622 19.7711 16.7335 19.6252 16.5403 19.4385C16.3472 19.2519 16.1936 19.0283 16.0886 18.781C15.9837 18.5337 15.9297 18.2678 15.9297 17.9992C15.9297 17.7306 15.9837 17.4647 16.0886 17.2175C16.1936 16.9702 16.3472 16.7466 16.5403 16.5599C16.7335 16.3732 16.9622 16.2274 17.213 16.131C17.4637 16.0346 17.7312 15.9896 17.9997 15.9988C18.5184 16.0166 19.0099 16.2351 19.3705 16.6083C19.7312 16.9815 19.9328 17.4802 19.9328 17.9992C19.9328 18.5182 19.7312 19.0169 19.3705 19.3901C19.0099 19.7633 18.5184 19.9819 17.9997 19.9996ZM5.9997 13.9996C5.73125 14.0088 5.46369 13.9639 5.21296 13.8675C4.96224 13.7711 4.73349 13.6252 4.54032 13.4385C4.34716 13.2519 4.19355 13.0283 4.08864 12.781C3.98373 12.5337 3.92966 12.2678 3.92966 11.9992C3.92966 11.7306 3.98373 11.4647 4.08864 11.2175C4.19355 10.9702 4.34716 10.7466 4.54032 10.5599C4.73349 10.3732 4.96224 10.2274 5.21296 10.131C5.46369 10.0346 5.73125 9.98964 5.9997 9.99883C6.51839 10.0166 7.0099 10.2351 7.37055 10.6083C7.7312 10.9815 7.93278 11.4802 7.93278 11.9992C7.93278 12.5182 7.7312 13.0169 7.37055 13.3901C7.0099 13.7633 6.51839 13.9819 5.9997 13.9996ZM17.9997 4.00117C18.2682 3.99198 18.5357 4.03692 18.7864 4.13331C19.0372 4.22971 19.2659 4.37558 19.4591 4.56224C19.6522 4.7489 19.8059 4.97253 19.9108 5.21981C20.0157 5.46709 20.0697 5.73295 20.0697 6.00156C20.0697 6.27018 20.0157 6.53604 19.9108 6.78332C19.8059 7.0306 19.6522 7.25423 19.4591 7.44089C19.2659 7.62755 19.0372 7.77342 18.7864 7.86981C18.5357 7.96621 18.2682 8.01115 17.9997 8.00195C17.481 7.9842 16.9895 7.76567 16.6289 7.39246C16.2682 7.01925 16.0666 6.52055 16.0666 6.00156C16.0666 5.48257 16.2682 4.98388 16.6289 4.61067C16.9895 4.23746 17.481 4.01893 17.9997 4.00117ZM17.9997 13.9996C16.7716 13.9996 15.6864 14.5645 14.9528 15.4363L9.94423 12.5465C9.96767 12.366 10.0005 12.1879 10.0005 12.0004C10.0005 11.8879 9.97705 11.7824 9.96767 11.6723L15.0817 8.71914C15.453 9.12314 15.904 9.44583 16.4062 9.66688C16.9084 9.88794 17.451 10.0026 17.9997 10.0035C18.7909 10.0035 19.5643 9.76893 20.2222 9.32943C20.88 8.88992 21.3928 8.26522 21.6957 7.53431C21.9986 6.8034 22.078 5.9991 21.9238 5.22308C21.7696 4.44707 21.3888 3.7342 20.8295 3.17459C20.2702 2.61497 19.5576 2.23375 18.7817 2.07911C18.0057 1.92448 17.2014 2.00337 16.4703 2.30582C15.7392 2.60827 15.1142 3.1207 14.6743 3.77832C14.2344 4.43593 13.9994 5.20921 13.9989 6.00039C13.9989 6.33321 14.0528 6.65196 14.1278 6.96133L9.30439 9.75039C8.91608 9.18033 8.38698 8.72035 7.76845 8.41509C7.14993 8.10983 6.46299 7.96967 5.77431 8.00821C5.08564 8.04674 4.41862 8.26268 3.83802 8.63504C3.25741 9.0074 2.78294 9.52355 2.46066 10.1334C2.13837 10.7432 1.97922 11.426 1.99866 12.1155C2.0181 12.805 2.21546 13.4777 2.57159 14.0684C2.92771 14.6591 3.43051 15.1477 4.03117 15.4868C4.63183 15.8258 5.30995 16.0038 5.9997 16.0035C7.30048 16.0012 8.44189 15.3707 9.17314 14.4098L14.0763 17.241C13.9194 18.0501 14.0161 18.8878 14.3533 19.6398C14.6906 20.3918 15.2518 21.0213 15.9603 21.4422C16.6688 21.8632 17.49 22.0551 18.3117 21.9917C19.1334 21.9283 19.9154 21.6126 20.5509 21.088C21.1865 20.5633 21.6445 19.8552 21.8623 19.0604C22.0802 18.2656 22.0473 17.4229 21.7681 16.6475C21.4889 15.8721 20.9771 15.2018 20.3026 14.7283C19.6281 14.2548 18.8238 14.0011 17.9997 14.002V13.9996Z"
                          fill="#121212"
                        ></path>
                      </svg>
                    </div>


                    {/* {isShareOpenlink ? <SocialMediaLink url={url} /> : null} */}

                    {isShareOpenlink ? (
                      <div style={{
                        position: 'absolute',
                        top: '56%',
                        right: '0',
                        marginRight: '110px',
                        zIndex: 1000
                      }}>
                        <SocialMediaLink url={url} />
                      </div>
                    ) : null}

                  </div>
                </div>
              </div>

              {(
                (
                  !eventDetailsData?.ads_details?.lister_basic_info?.hide_my_phone &&
                  eventDetailsData?.ads_details?.lister_basic_info?.primary_mobile_number?.primary_phone_number &&
                  eventDetailsData?.ads_details?.lister_basic_info?.primary_mobile_number?.primary_phone_number !== "undefined"
                ) ||
                (
                  !eventDetailsData?.ads_details?.lister_basic_info?.hide_my_secondary_phone &&
                  eventDetailsData?.ads_details?.lister_basic_info?.secondary_mobile_number?.secondary_phone_number &&
                  eventDetailsData?.ads_details?.lister_basic_info?.secondary_mobile_number?.secondary_phone_number !== "undefined"
                )
              ) && (
                  <>
                    <div className={Detailstyle.contact_deto}>
                      <h6>Contact Numbers :</h6>
                    </div>
                  </>)}


              {/* primary */}
              {!eventDetailsData?.ads_details?.lister_basic_info?.hide_my_phone &&
                eventDetailsData?.ads_details?.lister_basic_info?.primary_mobile_number?.primary_phone_number &&
                eventDetailsData?.ads_details?.lister_basic_info?.primary_mobile_number?.primary_phone_number !== "undefined" && (
                  <div className={Detailstyle.user_side_details}>
                    <div className={Detailstyle.call_details}>
                      <i className="fa-solid fa-phone"></i>{" "}
                      <p>
                        {eventDetailsData.ads_details.lister_basic_info
                          .hide_my_phone
                          ? ""
                          : `${eventDetailsData.ads_details.lister_basic_info
                            .primary_mobile_number.country_code
                            ? eventDetailsData.ads_details.lister_basic_info
                              .primary_mobile_number.country_code
                            : ""
                          } ${eventDetailsData.ads_details.lister_basic_info
                            .primary_mobile_number.primary_phone_number
                            ? eventDetailsData.ads_details.lister_basic_info
                              .primary_mobile_number.primary_phone_number
                            : ""
                          }`}

                      </p>
                    </div>
                    <div className={Detailstyle.headingdetails}>
                      <h4>
                        {getTimeSinceCreation(
                          eventDetailsData.ads_details.active_on_virtual
                        )}
                      </h4>
                    </div>
                  </div>
                )}

              {/* secondary */}
              {/* {eventDetailsData.ads_details.lister_basic_info.secondary_mobile_number
                ?.secondary_phone_number &&
                eventDetailsData.ads_details.lister_basic_info.secondary_mobile_number
                  ?.secondary_phone_number !== 'undefined' &&
                !eventDetailsData.ads_details.lister_basic_info.hide_my_secondary_phone && ( */}
              {!eventDetailsData?.ads_details?.lister_basic_info?.hide_my_secondary_phone &&
                eventDetailsData?.ads_details?.lister_basic_info?.secondary_mobile_number?.secondary_phone_number &&
                eventDetailsData?.ads_details?.lister_basic_info?.secondary_mobile_number?.secondary_phone_number !== "undefined" && (
                  <div className={Detailstyle.user_side_details}>
                    <div className={Detailstyle.call_details}>

                      {!eventDetailsData.ads_details.lister_basic_info.hide_my_secondary_phone &&
                        eventDetailsData.ads_details.lister_basic_info.secondary_mobile_number
                          ?.secondary_phone_number ? (
                        <i className="fa-solid fa-phone"></i>
                      ) : null}

                      <p>
                        {eventDetailsData.ads_details.lister_basic_info
                          .hide_my_secondary_phone &&
                          eventDetailsData.ads_details.lister_basic_info
                            .secondary_mobile_number.secondary_phone_number
                          ? `, `
                          : ""}

                        {eventDetailsData.ads_details.lister_basic_info
                          .hide_my_secondary_phone
                          ? ""
                          : eventDetailsData.ads_details.lister_basic_info
                            .secondary_mobile_number.secondary_phone_number
                            ? `${eventDetailsData.ads_details.lister_basic_info
                              .secondary_mobile_number.country_code
                              ? eventDetailsData.ads_details.lister_basic_info
                                .secondary_mobile_number.country_code
                              : ""
                            } ${eventDetailsData.ads_details.lister_basic_info
                              .secondary_mobile_number.secondary_phone_number
                            }`
                            : ""}
                      </p>
                    </div>
                    <div className={Detailstyle.headingdetails}>

                      <h4>
                        {/* {getTimeSinceCreation(
                      eventDetailsData.ads_details.active_on_virtual
                    )} */}
                        {eventDetailsData.ads_details.lister_basic_info.secondary_mobile_number
                          ?.secondary_phone_number &&
                          !eventDetailsData.ads_details.lister_basic_info.hide_my_secondary_phone ? (
                          <div className={Detailstyle.headingdetails}>
                            <h4>
                              {getTimeSinceCreation(eventDetailsData.ads_details.active_on_virtual)}
                            </h4>
                          </div>
                        ) : null}
                      </h4>
                    </div>
                  </div>
                )}

              <div className={Detailstyle.userimage_details_wrap}>
                <div className={Detailstyle.userimage_details_wrap1}>
                  <img src="src/assets/userr.png" alt="" />
                  <div className={Detailstyle.user_client_details}>
                    <p>
                      {eventDetailsData.ads_details.lister_basic_info.name
                        ? eventDetailsData.ads_details.lister_basic_info.name
                        : ""}
                    </p>
                    <span>Joined since  <span className={Detailstyle.form_Date}>
                      {formatDate(eventDetailsData.ads_details.userDetails.createdAt)}</span>
                    </span>
                  </div>
                </div>
                <div className={Detailstyle.view_profile}>
                  <Link
                    to={`/seller_profile/${eventDetailsData.ads_details.userId}`}
                    style={{ color: "#3897CC", fontWeight: "bold" }}>
                    View Profile
                  </Link>
                </div>
              </div>
            </div>
            <div className={Detailstyle.website_buton}>
              {websiteUrl && websiteUrl.trim() !== "" && linktoyourwebsite && (
                <button onClick={handleViewWebsite}>View website</button>
              )}
            </div>
            <div className={Detailstyle.call_button}>
              {(
                (!eventDetailsData?.ads_details?.lister_basic_info?.hide_my_phone &&
                  eventDetailsData?.ads_details?.lister_basic_info?.primary_mobile_number?.primary_phone_number &&
                  eventDetailsData?.ads_details?.lister_basic_info?.primary_mobile_number?.primary_phone_number !== "undefined") ||
                (!eventDetailsData?.ads_details?.lister_basic_info?.hide_my_secondary_phone &&
                  eventDetailsData?.ads_details?.lister_basic_info?.secondary_mobile_number?.secondary_phone_number &&
                  eventDetailsData?.ads_details?.lister_basic_info?.secondary_mobile_number?.secondary_phone_number !== "undefined")
              ) && (

                  <button onClick={handleCall}>Call</button>
                )}
              <button onClick={handleChat} className={Detailstyle.message_btn}>message</button>
            </div>
            <div className={Detailstyle.map_area_wrap}>
              <h2>{eventDetailsData.ads_details.adsInfo.location.location_name
                ? eventDetailsData.ads_details.adsInfo.location.location_name
                : ""}</h2>
              <div style={{ height: "30vh", width: "100%" }}>
                <GoogleMapReact
                  bootstrapURLKeys={{ key: "" }}
                  defaultCenter={defaultProps.center}
                  defaultZoom={defaultProps.zoom}
                >
                  <div
                    lat={originLat}
                    lng={originalLang}
                    style={{
                      color: "red", // Customize the color if needed
                      fontSize: "24px", // Adjust the size of the icon
                    }}
                  >
                    <i className="fa-solid fa-map-pin"></i>
                  </div>

                </GoogleMapReact>
              </div>
              {/* <img src="/images/Group 1686552430.png" alt="" /> */}
              <div className={Detailstyle.location_view_btn}>
                {/* <MapContainer/> */}
                {/* <button>view location</button> */}
              </div>
            </div>
            {!isMyReport && adsData?.userId && adsData.userId !== myUseriD && (
              <div>
                <div>
                  <button
                    className={Detailstyle.report_btn}
                    onClick={openModal}
                  >
                    REPORT THIS AD
                  </button>
                  <Modal
                    isOpen={modalIsOpen}
                    onAfterOpen={afterOpenModal}
                    onRequestClose={closeModal}
                    style={customStyles}
                    contentLabel="Example Modal"
                  >
                    <div className={Detailstyle.modal_box}>
                      <button
                        className={Detailstyle.close_button}
                        onClick={closeModal}
                      >
                        <i className="fa-solid fa-xmark"></i>
                      </button>

                      <input
                        type="radio"
                        id="report-radio"
                        style={{ display: "none" }}
                        checked={showOptions}
                        onChange={() => { }}
                      />
                      <div>
                        <p>What was wrong with this ad?</p>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          {reportingOptions.map((option) => (
                            <label key={option}>
                              <input
                                className={Detailstyle.inputRadio}
                                type="radio"
                                value={option}
                                checked={selectedOption === option}
                                onChange={handleOptionChange}
                              />
                              {option}
                              <br />
                            </label>
                          ))}
                          {selectedOption === "Other" && (
                            <div className={Detailstyle.custom_Msg}>
                              <form>
                                <input
                                  type="text"
                                  required
                                  placeholder="Enter message here"
                                  value={customMessage}
                                  onChange={(e) =>
                                    setCustomMessage(e.target.value)
                                  }
                                />
                              </form>
                            </div>
                          )}
                             {reportError && (
                            <p style={{ color: 'red', fontSize: '13px', marginBottom: '8px' }}>
                              {reportError}
                            </p>
                          )}
                          <button
                            className={Detailstyle.send_button}
                            onClick={handleSendReport}
                          >
                            Send
                          </button>
                        </div>
                      </div>
                    </div>
                  </Modal>
                </div>
                {/* {isReportSent && <p>Report has been sent. Thank you!</p>} */}
              </div>
            )}
          </div>

          {/* <h4 className={Detailstyle.report_text}>REPORT THIS AD</h4> */}

          {/*             
            <div>
                {adsData.userId !== myUseriD && (
                    <div>
                    <label
                        onClick={handleReportClick}
                        style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                    >
                        REPORT THIS AD
                    </label>
                    <input
                        type="radio"
                        id="report-radio"
                        style={{ display: 'none' }}
                        checked={showOptions}
                        onChange={() => {}}
                    />
                    {showOptions && (
                        <div>
                        <p>What was wrong with this ad?</p>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {reportingOptions.map((option) => (
                            <label key={option}>
                                <input
                                type="radio"
                                value={option}
                                checked={selectedOption === option}
                                onChange={handleOptionChange}
                                />
                                {option}
                                <br />
                            </label>
                            ))}
                            <button onClick={handleSendReport}>Send</button>
                            <button onClick={() => setShowOptions(false)}>Close</button>
                        </div>
                        </div>
                    )}
                    </div>
                )}
                {isReportSent && <p>Report has been sent. Thank you!</p>}
              </div>   */}
        </div>
      </div>

      <div className={Detailstyle.deatils_list_card_wrapper}>
        {relatedAdsdata.length > 0 ?
          <h2 className={Detailstyle.related_text}>Related Ads</h2>
          :
          ""}

        {/* <div className={Detailstyle.card_items}> */}
        {relatedAdsdata.length > 0 ? (
          <Carousel
            responsive={responsive}
            ssr
            infinite={true}
            containerClass="carousel-container"
            itemClass="carousel-item-padding-40-px"
          >
            {relatedAdsdata.map((items, index) => {
              return (
                <>
                  <div
                    className={Detailstyle.card_image}
                    onClick={() => {
                      buttonHnadler(items._id);
                    }}
                  >
                    <div className={Detailstyle.card_wrap_box}>
                      <div className={Detailstyle.cardimage}>
                        <div className={Detailstyle.fav_icon}>
                          {items.isfeatured == true ? (
                            <div className={Detailstyle.location_wrap}>
                              <svg
                                width="91"
                                height="26"
                                viewBox="0 0 91 26"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  y="0.935547"
                                  width="91"
                                  height="25"
                                  rx="4"
                                  fill="#F07639"
                                />
                                <path
                                  d="M14.7585 17.9355V9.20827H20.5369V10.7296H16.6037V12.8091H20.1534V14.3304H16.6037V17.9355H14.7585ZM21.7781 17.9355V9.20827H27.6587V10.7296H23.6232V12.8091H27.3562V14.3304H23.6232V16.4142H27.6758V17.9355H21.7781ZM30.63 17.9355H28.6527L31.6655 9.20827H34.0433L37.0518 17.9355H35.0746L32.8885 11.2026H32.8203L30.63 17.9355ZM30.5064 14.5051H35.1768V15.9455H30.5064V14.5051ZM36.7035 10.7296V9.20827H43.8711V10.7296H41.1992V17.9355H39.3754V10.7296H36.7035ZM50.4421 9.20827H52.2873V14.8759C52.2873 15.5123 52.1353 16.0691 51.8313 16.5463C51.5302 17.0236 51.1083 17.3958 50.5657 17.6628C50.0231 17.927 49.391 18.0591 48.6694 18.0591C47.945 18.0591 47.3114 17.927 46.7688 17.6628C46.2262 17.3958 45.8043 17.0236 45.5032 16.5463C45.2021 16.0691 45.0515 15.5123 45.0515 14.8759V9.20827H46.8967V14.7182C46.8967 15.0506 46.9691 15.3461 47.114 15.6046C47.2617 15.8631 47.4691 16.0662 47.7362 16.214C48.0032 16.3617 48.3143 16.4355 48.6694 16.4355C49.0273 16.4355 49.3384 16.3617 49.6026 16.214C49.8697 16.0662 50.0756 15.8631 50.2205 15.6046C50.3683 15.3461 50.4421 15.0506 50.4421 14.7182V9.20827ZM53.8054 17.9355V9.20827H57.2486C57.9077 9.20827 58.4702 9.32617 58.9361 9.56197C59.4048 9.79492 59.7614 10.1259 60.0057 10.5549C60.2528 10.981 60.3764 11.4824 60.3764 12.0591C60.3764 12.6387 60.2514 13.1373 60.0014 13.5549C59.7514 13.9696 59.3892 14.2878 58.9148 14.5094C58.4432 14.731 57.8722 14.8418 57.2017 14.8418H54.8963V13.3588H56.9034C57.2557 13.3588 57.5483 13.3105 57.7812 13.214C58.0142 13.1174 58.1875 12.9725 58.3011 12.7793C58.4176 12.5861 58.4759 12.3461 58.4759 12.0591C58.4759 11.7694 58.4176 11.525 58.3011 11.3262C58.1875 11.1273 58.0128 10.9767 57.777 10.8745C57.544 10.7694 57.25 10.7168 56.8949 10.7168H55.6506V17.9355H53.8054ZM58.5185 13.964L60.6875 17.9355H58.6506L56.5284 13.964H58.5185ZM61.6804 17.9355V9.20827H67.5611V10.7296H63.5256V12.8091H67.2585V14.3304H63.5256V16.4142H67.5781V17.9355H61.6804ZM72.1218 17.9355H69.0281V9.20827H72.1474C73.0252 9.20827 73.7809 9.38299 74.4144 9.73242C75.0479 10.079 75.5352 10.5776 75.8761 11.2282C76.2198 11.8787 76.3917 12.6571 76.3917 13.5634C76.3917 14.4725 76.2198 15.2537 75.8761 15.9071C75.5352 16.5605 75.0451 17.062 74.4059 17.4114C73.7695 17.7608 73.0082 17.9355 72.1218 17.9355ZM70.8732 16.3546H72.0451C72.5906 16.3546 73.0494 16.258 73.4215 16.0648C73.7965 15.8688 74.0778 15.5662 74.2653 15.1571C74.4556 14.7452 74.5508 14.214 74.5508 13.5634C74.5508 12.9185 74.4556 12.3915 74.2653 11.9824C74.0778 11.5733 73.7979 11.2722 73.4258 11.079C73.0536 10.8858 72.5948 10.7892 72.0494 10.7892H70.8732V16.3546Z"
                                  fill="#ffffff"
                                />
                              </svg>
                            </div>
                          ) : null}

                          {items.adsInfo.image.length > 0 ? (
                            <img
                              src={items.adsInfo.image[0].url}
                              width={"100%"}
                              height={200}
                              alt="Dummy"
                            />
                          ) : (
                            <img
                              src={BannerImage}
                              width={"100%"}
                              height={200}
                              alt="Dummy"
                            />
                          )}

                          <div className={Detailstyle.featured_ad}>
                            {items.addons_validity.some(
                              (item) => item.name === "Featured"
                            ) ? (
                              <svg
                                width="91"
                                height="26"
                                viewBox="0 0 91 26"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  y="0.935547"
                                  width="91"
                                  height="25"
                                  rx="4"
                                  fill="#F07639"
                                />
                                <path
                                  d="M14.7585 17.9355V9.20827H20.5369V10.7296H16.6037V12.8091H20.1534V14.3304H16.6037V17.9355H14.7585ZM21.7781 17.9355V9.20827H27.6587V10.7296H23.6232V12.8091H27.3562V14.3304H23.6232V16.4142H27.6758V17.9355H21.7781ZM30.63 17.9355H28.6527L31.6655 9.20827H34.0433L37.0518 17.9355H35.0746L32.8885 11.2026H32.8203L30.63 17.9355ZM30.5064 14.5051H35.1768V15.9455H30.5064V14.5051ZM36.7035 10.7296V9.20827H43.8711V10.7296H41.1992V17.9355H39.3754V10.7296H36.7035ZM50.4421 9.20827H52.2873V14.8759C52.2873 15.5123 52.1353 16.0691 51.8313 16.5463C51.5302 17.0236 51.1083 17.3958 50.5657 17.6628C50.0231 17.927 49.391 18.0591 48.6694 18.0591C47.945 18.0591 47.3114 17.927 46.7688 17.6628C46.2262 17.3958 45.8043 17.0236 45.5032 16.5463C45.2021 16.0691 45.0515 15.5123 45.0515 14.8759V9.20827H46.8967V14.7182C46.8967 15.0506 46.9691 15.3461 47.114 15.6046C47.2617 15.8631 47.4691 16.0662 47.7362 16.214C48.0032 16.3617 48.3143 16.4355 48.6694 16.4355C49.0273 16.4355 49.3384 16.3617 49.6026 16.214C49.8697 16.0662 50.0756 15.8631 50.2205 15.6046C50.3683 15.3461 50.4421 15.0506 50.4421 14.7182V9.20827ZM53.8054 17.9355V9.20827H57.2486C57.9077 9.20827 58.4702 9.32617 58.9361 9.56197C59.4048 9.79492 59.7614 10.1259 60.0057 10.5549C60.2528 10.981 60.3764 11.4824 60.3764 12.0591C60.3764 12.6387 60.2514 13.1373 60.0014 13.5549C59.7514 13.9696 59.3892 14.2878 58.9148 14.5094C58.4432 14.731 57.8722 14.8418 57.2017 14.8418H54.8963V13.3588H56.9034C57.2557 13.3588 57.5483 13.3105 57.7812 13.214C58.0142 13.1174 58.1875 12.9725 58.3011 12.7793C58.4176 12.5861 58.4759 12.3461 58.4759 12.0591C58.4759 11.7694 58.4176 11.525 58.3011 11.3262C58.1875 11.1273 58.0128 10.9767 57.777 10.8745C57.544 10.7694 57.25 10.7168 56.8949 10.7168H55.6506V17.9355H53.8054ZM58.5185 13.964L60.6875 17.9355H58.6506L56.5284 13.964H58.5185ZM61.6804 17.9355V9.20827H67.5611V10.7296H63.5256V12.8091H67.2585V14.3304H63.5256V16.4142H67.5781V17.9355H61.6804ZM72.1218 17.9355H69.0281V9.20827H72.1474C73.0252 9.20827 73.7809 9.38299 74.4144 9.73242C75.0479 10.079 75.5352 10.5776 75.8761 11.2282C76.2198 11.8787 76.3917 12.6571 76.3917 13.5634C76.3917 14.4725 76.2198 15.2537 75.8761 15.9071C75.5352 16.5605 75.0451 17.062 74.4059 17.4114C73.7695 17.7608 73.0082 17.9355 72.1218 17.9355ZM70.8732 16.3546H72.0451C72.5906 16.3546 73.0494 16.258 73.4215 16.0648C73.7965 15.8688 74.0778 15.5662 74.2653 15.1571C74.4556 14.7452 74.5508 14.214 74.5508 13.5634C74.5508 12.9185 74.4556 12.3915 74.2653 11.9824C74.0778 11.5733 73.7979 11.2722 73.4258 11.079C73.0536 10.8858 72.5948 10.7892 72.0494 10.7892H70.8732V16.3546Z"
                                  fill="#ffffff"
                                />
                              </svg>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                      {tokenExist && (
                        <div className={Detailstyle.hearty}>
                          {!favStatus2[index] ? (
                            <div
                              onClick={(event) => {
                                event.preventDefault();
                                handleHeartIconClick2(event, index, items._id);
                              }}
                            >
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_181_9810)">
                                  <path
                                    d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                                    fill="white"
                                  />
                                  <path
                                    d="M15.5591 10.9359L15.9594 11.471L16.3598 10.9359C17.0879 9.96261 18.2546 9.33008 19.5558 9.33008C21.764 9.33008 23.5593 11.1288 23.5593 13.358C23.5593 14.2675 23.4143 15.1066 23.1624 15.8851L23.1614 15.8884C22.5573 17.8001 21.3181 19.3442 19.9761 20.4976C18.6318 21.6529 17.2131 22.3913 16.3006 22.7018L16.3006 22.7018L16.2952 22.7037C16.2277 22.7275 16.1059 22.7481 15.9594 22.7481C15.8129 22.7481 15.6912 22.7275 15.6236 22.7037L15.6236 22.7036L15.6183 22.7018C14.7058 22.3913 13.287 21.6529 11.9427 20.4976C10.6006 19.3442 9.36144 17.8001 8.75734 15.8884L8.75735 15.8884L8.7563 15.8851C8.50442 15.1066 8.35938 14.2675 8.35938 13.358C8.35938 11.1289 10.1547 9.33008 12.363 9.33008C13.6642 9.33008 14.8309 9.96261 15.5591 10.9359Z"
                                    stroke="black"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_181_9810">
                                    <rect
                                      width="32"
                                      height="32"
                                      fill="white"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                          ) : (
                            <div
                              onClick={(event) => {
                                event.preventDefault();
                                handleHeartIconClick2(event, index, items._id);
                              }}
                            >
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_315_9939)">
                                  <path
                                    d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                                    fill="white"
                                  />
                                  <path
                                    d="M19.5558 8.83008C18.0897 8.83008 16.7775 9.54288 15.9594 10.6364C15.1413 9.54288 13.8291 8.83008 12.363 8.83008C9.87627 8.83008 7.85938 10.8551 7.85938 13.358C7.85938 14.3219 8.01327 15.2129 8.28057 16.0391C9.56037 20.0891 13.5051 22.511 15.4572 23.1752C15.7326 23.2724 16.1862 23.2724 16.4616 23.1752C18.4137 22.511 22.3583 20.0891 23.6381 16.0391C23.9054 15.2129 24.0593 14.3219 24.0593 13.358C24.0593 10.8551 22.0425 8.83008 19.5558 8.83008Z"
                                    fill="#FF7700"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_315_9939">
                                    <rect
                                      width="32"
                                      height="32"
                                      fill="white"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                          )}
                        </div>
                      )}

                      <div className={Detailstyle.container}>
                        <div className={Detailstyle.heading_section}>
                          <h6>{items.adsInfo.title}</h6>


                          <>
                            {items.addons_validity.length > 0 && (
                              items.addons_validity.map((addon, index) => (
                                addon.name === "Urgent" && (
                                  <button
                                    key={index}
                                    style={{ backgroundColor: "red" }}
                                  >
                                    {addon.name}
                                  </button>
                                )
                              ))
                            )}
                          </>


                          {/* {
                                                                items.addons_validity.length > 0 ? (
                                                                    <>
                                                                   {
                                                                    items.addons_validity[0].name=="Homepage Gallery"?null:(
                                                                    <button style={{ backgroundColor: items.addons_validity[0].name === "Urgent" ? "red" : "blue" }}>
                                                                        {items.addons_validity[0].name}
                                                                    </button>
                                                                    )
                                                                   }
                                                                   </>
                                                                ) : null
                                                            }  */}
                        </div>

                        {/* <p className={Detailstyle.job_text}> <div dangerouslySetInnerHTML={{__html:items.adsInfo.descriptions}}></div></p> */}

                        <div className={Detailstyle.location_box}>
                          <div className={Detailstyle.location_icon}>
                            <img src="/images/location pin.svg" alt="logo" />
                            <p>{items.adsInfo.location.location_name}</p>
                          </div>
                          <div className={Detailstyle.time}>
                            <img src="/src/assets/image 7.png" alt="" />
                            {/* <p>15 Dec 2022</p> */}
                          </div>
                        </div>
                        <div className={Detailstyle.detail_box}>
                          <div>


                            <p style={{ color: "green" }}>
                              {items.price_drop ? (
                                <>
                                  <s style={{ color: "black" }}>
                                    {items.adsInfo.price.amount === 0
                                      ? "Free"
                                      : items.adsInfo.price.amount
                                        ? `${getSymbolFromCurrency(
                                          items.adsInfo.price.currency
                                        )}${items.adsInfo.price.amount} `
                                        : ""}
                                  </s>{" "}
                                  {items.adsInfo.price.amount
                                    ? getSymbolFromCurrency(
                                      items.adsInfo.price.currency
                                    ) + items.price_drop
                                    : ""}
                                </>
                              ) : (
                                <>
                                  {items.adsInfo.price.amount === 0
                                    ? "Free"
                                    : items.adsInfo.price.amount
                                      ? `${getSymbolFromCurrency(
                                        items.adsInfo.price.currency
                                      )} ${items.adsInfo.price.amount} ${items.adsInfo.price.currency
                                      }`
                                      : ""}{" "}
                                  {items.adsInfo.price.negotiable === true
                                    ? "Negotiable"
                                    : items.adsInfo.price.is_contact === true
                                      ? "Please contact"
                                      : null}
                                </>
                              )}
                            </p>

                          </div>
                          <div
                            onClick={(event) => {
                              shareSocialMediaLink(event, items._id);
                            }}
                          >
                            <svg
                              width="24"
                              height="25"
                              viewBox="0 0 24 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M17.9997 20.4896C17.7312 20.4988 17.4637 20.4539 17.213 20.3575C16.9622 20.2611 16.7335 20.1152 16.5403 19.9285C16.3472 19.7419 16.1936 19.5182 16.0886 19.271C15.9837 19.0237 15.9297 18.7578 15.9297 18.4892C15.9297 18.2206 15.9837 17.9547 16.0886 17.7075C16.1936 17.4602 16.3472 17.2365 16.5403 17.0499C16.7335 16.8632 16.9622 16.7174 17.213 16.621C17.4637 16.5246 17.7312 16.4796 17.9997 16.4888C18.5184 16.5066 19.0099 16.7251 19.3705 17.0983C19.7312 17.4715 19.9328 17.9702 19.9328 18.4892C19.9328 19.0082 19.7312 19.5069 19.3705 19.8801C19.0099 20.2533 18.5184 20.4718 17.9997 20.4896ZM5.9997 14.4896C5.73125 14.4988 5.46369 14.4539 5.21296 14.3575C4.96224 14.2611 4.73349 14.1152 4.54032 13.9285C4.34716 13.7419 4.19355 13.5182 4.08864 13.271C3.98373 13.0237 3.92966 12.7578 3.92966 12.4892C3.92966 12.2206 3.98373 11.9547 4.08864 11.7075C4.19355 11.4602 4.34716 11.2365 4.54032 11.0499C4.73349 10.8632 4.96224 10.7174 5.21296 10.621C5.46369 10.5246 5.73125 10.4796 5.9997 10.4888C6.51839 10.5066 7.0099 10.7251 7.37055 11.0983C7.7312 11.4715 7.93278 11.9702 7.93278 12.4892C7.93278 13.0082 7.7312 13.5069 7.37055 13.8801C7.0099 14.2533 6.51839 14.4718 5.9997 14.4896ZM17.9997 4.49116C18.2682 4.48197 18.5357 4.52691 18.7864 4.6233C19.0372 4.7197 19.2659 4.86557 19.4591 5.05223C19.6522 5.23889 19.8059 5.46252 19.9108 5.7098C20.0157 5.95708 20.0697 6.22294 20.0697 6.49155C20.0697 6.76017 20.0157 7.02603 19.9108 7.27331C19.8059 7.52059 19.6522 7.74422 19.4591 7.93088C19.2659 8.11754 19.0372 8.26341 18.7864 8.35981C18.5357 8.4562 18.2682 8.50114 17.9997 8.49194C17.481 8.47419 16.9895 8.25566 16.6289 7.88245C16.2682 7.50924 16.0666 7.01054 16.0666 6.49155C16.0666 5.97256 16.2682 5.47387 16.6289 5.10066C16.9895 4.72745 17.481 4.50892 17.9997 4.49116ZM17.9997 14.4896C16.7716 14.4896 15.6864 15.0544 14.9528 15.9263L9.94423 13.0365C9.96767 12.856 10.0005 12.6779 10.0005 12.4904C10.0005 12.3779 9.97705 12.2724 9.96767 12.1623L15.0817 9.20913C15.453 9.61313 15.904 9.93582 16.4062 10.1569C16.9084 10.3779 17.451 10.4925 17.9997 10.4935C18.7909 10.4935 19.5643 10.2589 20.2222 9.81942C20.88 9.37991 21.3928 8.75521 21.6957 8.0243C21.9986 7.29339 22.078 6.48909 21.9238 5.71307C21.7696 4.93706 21.3888 4.22419 20.8295 3.66458C20.2702 3.10496 19.5576 2.72374 18.7817 2.56911C18.0057 2.41447 17.2014 2.49336 16.4703 2.79581C15.7392 3.09826 15.1142 3.61069 14.6743 4.26831C14.2344 4.92592 13.9994 5.6992 13.9989 6.49038C13.9989 6.8232 14.0528 7.14195 14.1278 7.45132L9.30439 10.2404C8.91608 9.67032 8.38698 9.21034 7.76845 8.90508C7.14993 8.59982 6.46299 8.45966 5.77431 8.4982C5.08564 8.53673 4.41862 8.75267 3.83802 9.12503C3.25741 9.49739 2.78294 10.0135 2.46066 10.6234C2.13837 11.2332 1.97922 11.916 1.99866 12.6055C2.0181 13.2949 2.21546 13.9677 2.57159 14.5584C2.92771 15.1491 3.43051 15.6377 4.03117 15.9768C4.63183 16.3158 5.30995 16.4938 5.9997 16.4935C7.30048 16.4912 8.44189 15.8607 9.17314 14.8998L14.0763 17.731C13.9194 18.5401 14.0161 19.3778 14.3533 20.1298C14.6906 20.8818 15.2518 21.5112 15.9603 21.9322C16.6688 22.3532 17.49 22.5451 18.3117 22.4816C19.1334 22.4182 19.9154 22.1026 20.5509 21.578C21.1865 21.0533 21.6445 20.3452 21.8623 19.5504C22.0802 18.7555 22.0473 17.9129 21.7681 17.1375C21.4889 16.3621 20.9771 15.6918 20.3026 15.2183C19.6281 14.7448 18.8238 14.4911 17.9997 14.4919V14.4896Z"
                                fill="#6D737A"
                              />
                            </svg>
                            {isShareOpen && shareID == items._id ? (
                              <SocialMediaLink url={url} />
                            ) : null}
                          </div>
                          {/* <div className={Detailstyle.eye_icon}>
                                        <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.00049 12.8839C2.00049 12.8839 5.00049 5.65405 12.0005 5.65405C19.0005 5.65405 22.0005 12.8839 22.0005 12.8839C22.0005 12.8839 19.0005 20.1137 12.0005 20.1137C5.00049 20.1137 2.00049 12.8839 2.00049 12.8839Z" stroke="#6D737A" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12 15.9824C13.6569 15.9824 15 14.5951 15 12.8839C15 11.1726 13.6569 9.7854 12 9.7854C10.3431 9.7854 9 11.1726 9 12.8839C9 14.5951 10.3431 15.9824 12 15.9824Z" stroke="#6D737A" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        <span>569</span>
                                    </div> */}
                        </div>

                        <span>{getTimeSinceCreation(items.active_on_virtual)}</span>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </Carousel>
        ) : null}
        {/* </div> */}
      </div>
      <div className={Detailstyle.deatils_logo_image}>
        {/* <img src={addFreeImage} alt="" style={{ width: "100%" }} /> */}
        <Banner bottombanner={true} />
      </div>
    </>
  );
}

export default Local_Details;
